export enum CauseAreaMetricsDialogTabs {
  causeAreas,
  salesUsers,
}
